import React from 'react';
import { Button } from './Button';
import { FadeIn } from './FadeIn';
import { Crown, Download, ShieldCheck, Zap } from 'lucide-react';
const MASTER_SYSTEM_CHECKOUT = 'https://43skvt-1y.myshopify.com/products/sistema-completo-de-ventas-en-amazon-fba-fbm-2026';
export function Hero() {
  const beginNow = () => {
    window.open(MASTER_SYSTEM_CHECKOUT, '_blank', 'noopener,noreferrer');
  };
  return <section className="bg-brand-white px-5 pb-24 pt-16 sm:px-6 md:pb-32 md:pt-24" data-id="element-315">
      <div className="mx-auto max-w-6xl" data-id="element-316">
        <div className="grid items-center gap-12 lg:grid-cols-[0.9fr_1.1fr] lg:gap-16" data-id="element-317">
          <div className="order-2 text-center lg:order-1 lg:text-left" data-id="element-318">
            <FadeIn data-id="element-319">
              <div className="mb-7 inline-flex items-center gap-2 rounded-full border border-brand-gold/40 bg-brand-beige px-4 py-2 text-[11px] font-bold uppercase tracking-[0.16em] text-brand-green" data-id="element-320">
                <Crown className="h-3.5 w-3.5 text-brand-gold" data-id="element-321" />
                Amazon Master System™
              </div>
            </FadeIn>

            <FadeIn delay={0.1} data-id="element-322">
              <h1 className="font-serif text-4xl font-bold leading-[1.08] tracking-tight text-brand-green sm:text-5xl md:text-6xl" data-id="element-323">
                Aprende a vender en Amazon desde cero con un método paso a paso.
              </h1>
            </FadeIn>

            <FadeIn delay={0.18} data-id="element-324">
              <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-brand-text/70 sm:text-lg lg:mx-0" data-id="element-325">
                Un programa completo que reúne todo lo que necesitas para
                comenzar en Amazon FBA y FBM desde cero, incluso si nunca has
                vendido por internet.
              </p>
            </FadeIn>

            <FadeIn delay={0.26} data-id="element-326">
              <div className="mx-auto mt-9 max-w-md lg:mx-0" data-id="element-327">
                <Button onClick={beginNow} aria-label="Comenzar ahora" className="w-full" data-id="element-328">
                  COMENZAR AHORA
                </Button>

                <div className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-medium text-brand-text/55 lg:justify-start" data-id="element-329">
                  <span className="flex items-center gap-1.5" data-id="element-330">
                    <Zap className="h-3.5 w-3.5 text-brand-green" data-id="element-331" />
                    Acceso inmediato
                  </span>
                  <span className="flex items-center gap-1.5" data-id="element-332">
                    <Download className="h-3.5 w-3.5 text-brand-green" data-id="element-333" />
                    Descarga digital
                  </span>
                  <span className="flex items-center gap-1.5" data-id="element-334">
                    <ShieldCheck className="h-3.5 w-3.5 text-brand-green" data-id="element-335" />
                    Compra segura
                  </span>
                </div>
              </div>
            </FadeIn>
          </div>

          <FadeIn delay={0.12} data-id="element-336">
            <div className="order-1 mx-auto w-full max-w-2xl lg:order-2" data-id="element-337">
              <img src="https://cdn.magicpatterns.com/uploads/tioDqWBANZPtQH21RpwvZP/sistema_completo.png" alt="Sistema Completo Amazon FBA + FBM" className="h-auto w-full rounded-2xl object-contain shadow-[0_30px_80px_-24px_rgba(26,26,26,0.28)]" data-id="element-338" />
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}